/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Vekn_Link_DescriptionInputs */



/**
* | output |
* | --- |
* | "Link an existing VEKN ID to {name}. If someone else has it, they lose it." |
*
* @param {Vekn_Link_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_link_description = /** @type {((inputs: Vekn_Link_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Link_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Associer un ID VEKN existant à ${i?.name}. Si quelqu'un d'autre l'a, il le perd.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Vincular un ID VEKN existente a ${i?.name}. Si otra persona lo tiene, lo pierde.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Vincular um ID VEKN existente a ${i?.name}. Se outra pessoa o tiver, ela o perde.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Collega un ID VEKN esistente a ${i?.name}. Se ce l'ha qualcun altro, lo perde.`)
	return /** @type {LocalizedString} */ (`Link an existing VEKN ID to ${i?.name}. If someone else has it, they lose it.`)
});